<template>
  <template v-if="version === 1">
    <div class="row mt-3">
      <div class="col">
        <div class="image-container">
          <div class="image">
            <div v-if="loading" class="content-loader">
              <Spinner />
            </div>
            <img ref="imageRef" v-show="!loading" :src="image" @load="loading = false" />
          </div>
        </div>

        <FormControl
            label-disabled
            input-class="text-center"
            name="captcha"
            :placeholder="$t('global.enter_captcha')"
        />
      </div>
    </div>
  </template>

  <div v-if="version === 2"
       class="captcha"
  >
    <div class="g-recaptcha mt-2" :data-sitekey="siteKey" />
  </div>

  <template v-else>
    <input type="hidden" name="g-recaptcha-response" :value="token" />
  </template>
</template>
<script setup>
import {computed, inject, onMounted, ref} from "vue";
import FormControl from "@/js/Elements/Form/FormControl.vue";
import Spinner from "@/js/Elements/Spinner.vue";

const settings = computed(() => window.setup.login?.captcha);
const image = computed(() => settings.value?.img);
const siteKey = computed(() => settings.value?.key);
const version = computed(() => settings.value?.version);
const formProgress = inject('form:progress');
const token = ref(null);
const loading = ref(!!image.value);
const formErrors = inject('form:errors');
const imageRef = ref();

onMounted(setup);
defineExpose({
  reload() {
    if (!imageRef.value) return;
    imageRef.value.src = `${image.value}?t=${Date.now()}`;
    loading.value = true;
  }
})

async function setup() {
  if (version.value === 1) return;

  if (version.value === 2) {
    return createScript();
  }

  createScript(siteKey.value);
}

function createScript(render) {
  let s = document.querySelector('#captcha');
  if (s) return;

  s = document.createElement('script');
  s.id = 'captcha';
  s.src = `https://www.google.com/recaptcha/api.js`;
  s.onerror = function (e) {
    formErrors.captcha = 'reCAPTCHA: unable to load "reCAPTCHA". Please check site key.';
    formProgress.value = false;
  }

  if (render) {
    formProgress.value = true
    s.src += `?render=${siteKey.value}`;
    s.onload = function () {
      grecaptcha.ready(() => {
        grecaptcha.execute(siteKey.value, {action: 'submit'}).then((t) => {
          token.value = t;
          formProgress.value = false;
        }).catch((error) => {
          formErrors.captcha = error?.message || error?.toString() || 'reCAPTCHA: Unknown error'
          formProgress.value = false;
        });
      });
    }
  }

  s.async = true;
  s.defer = true;
  document.head.appendChild(s);
}
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.captcha {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: spacing(2);
}

.image {
  width: 100%;
  display: flex;
  justify-content: center;
  min-height: toRem(60);
  background-color: #e1e6e8;
  border-radius: $border-radius-xl;

  &-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: spacing(2);
  }
}
</style>